"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchKevelAnalyticsEvent = exports.dispatchCitrusAnalyticsEvent = void 0;
const dispatchCitrusAnalyticsEvent = (detail) => {
    if ((document === null || document === void 0 ? void 0 : document.body) &&
        detail &&
        detail.action &&
        detail.type &&
        detail.adId &&
        detail.campaignName) {
        document.body.dispatchEvent(new CustomEvent("dataStateChange", { detail }));
    }
};
exports.dispatchCitrusAnalyticsEvent = dispatchCitrusAnalyticsEvent;
const dispatchKevelAnalyticsEvent = (detail) => {
    var _a, _b;
    if ((document === null || document === void 0 ? void 0 : document.body) &&
        detail &&
        detail.action &&
        detail.type &&
        detail.adId &&
        detail.clickUrl &&
        detail.impressionUrl) {
        document.body.dispatchEvent(new CustomEvent("dataStateChange", { detail }));
        // reports to New Relic; unrelated to the dataStateChange event above
        (_b = (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) === null || _b === void 0 ? void 0 : _b.call(_a, detail.action === "kevel.impression" ? "kevelImpression" : "kevelClicked", { esiType: detail.esiType, adId: detail.adId });
    }
};
exports.dispatchKevelAnalyticsEvent = dispatchKevelAnalyticsEvent;
